<template>
  <LandingPage />
</template>

<script>
import LandingPage from "@/components/LandingPage/LandingPage.vue";

export default {
  name: "Home",
  components: {
    LandingPage,
  },
  mounted() {
    document.title = "AMA-Home";
  },
};
</script>
